/**
 * クラス名：板金のブランクの2工程穴加工時間画面
 * 作成者：チュー
 * 作成日：2023/06/28
 * バージョン：1.0
 */
import React, { useEffect, forwardRef, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Row, Col, Input } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';

import {
  souchiHandleIncreaseTime,
  souchiHandleDecreaseTime,
  secondsToHms,
  setTimetoSec,
  TimeInputParameterScreen,
} from '../../../common/Common';

const Device_Blank_DrillingTime = forwardRef((props, ref) => {
  const [editMode, setEditMode] = useState(false);
  const [drillingTime, setDrillingTime] = useState();
  useEffect(() => {
    setEditMode(props.editMode);
    setDrillingTime(props?.detailsData?.twoStepHoleworkTime);
  }, [props.editMode, props.detailsData]);
  const changeTime = (e) => {
    setDrillingTime(e);
    props.updateDrillingTime(e);
  };
  return (
    <>
      <Row className="chargeAmount" style={{ marginLeft: 10, marginRight: 10 }}>
        <Col style={{ width: '20%' }}>
          <Table>
            <thead>
              <tr style={{ textAlign: 'center', height: 30 }}>
                <td className="param-tbl-header">2工程穴加工時間</td>
              </tr>
            </thead>
            <tbody>
              <tr style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                <td>
                  <Row align="middle">
                    {!editMode ? (
                      <>
                        <Col span={24}>
                          <label>{secondsToHms(drillingTime)}</label>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col>
                          <TimeInputParameterScreen
                            value={secondsToHms(drillingTime)}
                            onBlur={(event) => changeTime(setTimetoSec(event.target.value))}
                          />
                        </Col>
                        {/* 2025-05-21 パラメータで複合機の二工程穴加工時間を編集する際に、
                            画面の横幅を狭くすると▲▼が2段になってしまう。
                            ▲▼が存在する部分は全てこの現象が起きると思う。
                            可能であれば画面の横幅の変更によって2段に別れたりしないようにしてほしい */}
                        <Col flex="1 1 auto">
                          <div
                            style={{
                              display: 'flex',
                              flexWrap: 'nowrap',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 1,
                              overflow: 'hidden',
                            }}
                          >
                            {[
                              ['10min', 'up'],
                              ['10min', 'down'],
                              ['min', 'up'],
                              ['min', 'down'],
                              ['sec', 'up'],
                              ['sec', 'down'],
                            ].map(([unit, dir], i) => {
                              const Icon = dir === 'up' ? CaretUpOutlined : CaretDownOutlined;
                              return (
                                <Icon
                                  key={i}
                                  style={{
                                    fontSize: 'clamp(12px, 1.4vw, 16px)',
                                    color: '#000',
                                    pointerEvents: editMode ? 'auto' : 'none',
                                    flexShrink: 0,
                                  }}
                                  onClick={() => {
                                    const fn = dir === 'up' ? souchiHandleIncreaseTime : souchiHandleDecreaseTime;
                                    const editedTime = fn(secondsToHms(drillingTime), unit);
                                    changeTime(setTimetoSec(editedTime));
                                  }}
                                />
                              );
                            })}
                          </div>
                        </Col>
                      </>
                    )}
                  </Row>
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
});

export default Device_Blank_DrillingTime;
